import React, { Component } from "react";
import { View, TouchableOpacity, TouchableWithoutFeedback, Image, FlatList } from "react-native";
import TextView from "./TextView";
import { appStyles, homeStyles } from '../theme/styles'
import { icons } from "../theme/icons";
import LinearGradient from "react-native-linear-gradient";
import { yellowDarkColor, yellowLightColor, blueLightColor, blueDarkColor } from "../theme/colors";
import { checkExpertFavRequest, myfavoritServantRequest } from "../utils/api";
import Waiting from "./Waiting";
import { showMessage } from "../utils/utils";
import ChoseServantItem from "./ChoseServantItem";
import { wp } from "../utils/responsive";

class DialogFavExper extends Component {
    constructor(props) {
        super(props);
        this.state = {
            show: props.show,
            sex: props.sex,
            waiting: false,
            experts: [],
            showExperts: false,
        }
        this.onClose = this.onClose.bind(this)
    }

    onClose() {
        this.setState({
            show: false
        })
        this.props.onClose()
    }

    onNearExpert() {
        this.setState({
            show: false
        })
        this.props.onNearExpert()
    }
    onFavExpert(id) {
        this.setState({
            show: false
        })
        this.props.onFavExpert(id)
    }
    _keyExtractor = (item, index) => index.toString();
    renderFavoritRow({ item }) {
        return <ChoseServantItem
            data={item}
            onChosen={() => {
                this.onFavExpert(item.id)
            }}
        />
    }

    render() {
        return (
            this.state.show?<TouchableWithoutFeedback onPress={() => {
                    this.onClose()
                }}>
                    <View style={appStyles.modalMessageAbsolute} >
                        {!this.state.showExperts ? <View style={[appStyles.modalMessageContent, { paddingTop: 20, paddingBottom: 20 }]}>
                            <Image source={icons['nurse']} style={[homeStyles.bicon, { tintColor: '#69f0ae', margin: 15 }]} />
                            <TextView style={{ fontSize: 16, textAlign: 'center' }}>تمایل به گرفتن خدمت از کدام گزینه هستید ؟</TextView>
                            <View style={[appStyles.rowAround, { marginTop: 10, marginBottom: 15 }]}>
                                <TouchableOpacity onPress={() => {
                                    this.setState({
                                        waiting: true
                                    })
                                    checkExpertFavRequest(this.state.sex, (isConnect, response) => {
                                        this.setState({
                                            waiting: false
                                        })
                                        if (isConnect) {
                                            if (response.data.length > 0) {
                                                this.setState({
                                                    experts: response.data,
                                                    showExperts: true
                                                })
                                            } else {
                                                showMessage('', 'درمانگر منتخبی یافت نشد ، میتوانید از گزینه درمانگران نزدیک استفاده نمایید');
                                            }

                                        }
                                    })

                                }}>
                                    <LinearGradient start={{ x: 0, y: 0 }} end={{ x: 1, y: 0 }}
                                        colors={[yellowLightColor, yellowDarkColor]} style={homeStyles.favExbutton}>
                                        <TextView style={{ color: 'white' }}>درمانگر منتخب</TextView>
                                        <Image source={icons['star_empty']} style={homeStyles.sicon} />
                                    </LinearGradient>
                                </TouchableOpacity>
                                <TouchableOpacity onPress={() => {
                                    this.onNearExpert()
                                }}>
                                    <LinearGradient start={{ x: 0, y: 0 }} end={{ x: 1, y: 0 }}
                                        colors={[blueLightColor, blueDarkColor]} style={homeStyles.favExbutton}>
                                        <TextView style={{ color: 'white' }}>درمانگران نزدیک</TextView>
                                        <Image source={icons['pinmap']} style={homeStyles.sicon} />
                                    </LinearGradient>
                                </TouchableOpacity>
                            </View>
                            <TextView style={{ textAlign: 'center', fontSize: 12, margin: 10, color: 'gray' }}><TextView isbold={true}> توضیحات : </TextView>در صورت استفاده از گزینه درمانگران منتخب درخواست شما فقط برای فرد مورد نظر ارسال خواهد شد</TextView>
                        </View> : null}
                        {this.state.showExperts ? <View style={[appStyles.modalMessageContent]}>
                            <View style={[appStyles.rowBetween, { width: wp(90) }]}>
                                <TouchableOpacity onPress={() => {
                                    this.setState({
                                        showExperts: false
                                    })
                                }}>
                                    <TextView style={{ color: 'gray' }}>بازگشت</TextView>
                                </TouchableOpacity>
                                <TextView isbold={true}>انتخاب درمانگر</TextView>
                            </View>
                            <FlatList
                                data={this.state.experts}
                                renderItem={this.renderFavoritRow.bind(this)}
                                keyExtractor={this._keyExtractor}
                            />
                        </View> : null}
                        <Waiting waiting={this.state.waiting} />
                    </View>
                </TouchableWithoutFeedback>:<View/>
        );
    }
    componentWillReceiveProps(newprops) {
        this.setState({
            show: newprops.show,
            sex: newprops.sex,
        })
    }
}

export default DialogFavExper;
